
import { convertHeight } from "../../../utils/common";

const INCH_TO_CM_FACTOR = 2.54;
const FEET_TO_CM_FACTOR = 30.48;
const FT_TO_IN_FACTOR = 12;

export class Height {
    constructor(height1, height2, unit = 'cm') {
        this.height1 = parseFloat(height1);
        this.height2 = parseFloat(height2);
        this.unit = unit;
    }
    create(height) {
        let heightObj = height
        if (typeof height === 'string') {
            heightObj = JSON.parse(height);
        }
        return new Height(heightObj.height1, heightObj.height2, heightObj.unit);
    }

    getHeightWithUnitM() {
        if (this.unit === 'cm') {
            return this.height1/ 100;
        } else {
            return (this.height1 * FEET_TO_CM_FACTOR + this.height2 * INCH_TO_CM_FACTOR) / 100;
        }

    }
    toPlainObject() {
        return  {
            height1: this.height1,
            height2: this.height2,
            unit: this.unit
        };
    }

    getUnit() {
        if (this.unit === "cm") {
            return 3;
        }
        return 2;
    }
    getHeight() {
        if (this.unit === 'cm') {
            return this.height1;
        } else {
            return this.height1 * FT_TO_IN_FACTOR + this.height2;
        }
    }

    // 单位转换方法 - 使用utils中的转换函数
    convertHeight(value, fromUnit, toUnit) {
        return convertHeight(value, fromUnit, toUnit);
    }

    // 转换当前实例的单位
    convertToUnit(newUnit) {
        if (this.unit === newUnit) return this;
        
        const newHeight1 = convertHeight(this.height1, this.unit, newUnit);
        const newHeight2 = convertHeight(this.height2, this.unit, newUnit);
        
        return new Height(newHeight1, newHeight2, newUnit);
    }
}

export default Height;